<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="formInline.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="物流单号"><el-input size="small" v-model="formInline.express_no" placeholder="请输入物流单号"></el-input></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-form-item>
            <el-button size="small" @click="addClick()" type="success" icon="el-icon-search" v-auth="'/plus/express/index/add'">添加</el-button>
          </el-form-item>
          <el-button
            type="primary"
            v-auth="'/plus/express/index/ulogistics'"
            @click="openFullScreen2">
            一键更新物流状态
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
         
          <el-table-column prop="order_out_no" label="订单号"  align="center">
            <template slot-scope="scope">
               <p>
                {{scope.row.order_out_no}}   
               </p>
                
            </template>
          </el-table-column>
          <el-table-column prop="order_id" label="类别"  align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.order_id>0">内部订单</el-tag>
              <el-tag type="success" v-else>外部订单</el-tag>
                
            </template>
          </el-table-column>
          <el-table-column prop="express" label="快递公司"  align="center">
            <template slot-scope="scope">
               <p v-if="scope.row.express">{{scope.row.express.express_name}}</p>            
            </template>
          </el-table-column>
          <el-table-column prop="express_no" label="物流单号"  align="center"></el-table-column>
          <el-table-column prop="" label="物流状态"  align="center">
            
            <template slot-scope="scope" v-if="scope.row.express_text">
              <div v-if="scope.row.express_text==''">暂无物流状态</div>
              <div v-else>{{scope.row.express_text.list.list[0].status}}</div>    
            </template>
          </el-table-column>
          <el-table-column prop="" label="更新时间"  align="center" >
            
            <template slot-scope="scope" v-if="scope.row.express_text">
              <div v-if="scope.row.express_text==''">暂无物流状态</div>
              <div v-else>{{scope.row.express_text.list.updateTime}}</div>    
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="track(scope.row)" type="text" size="small"  v-auth="'/plus/express/index/refreshOne'">查询物流</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/express/index/update'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/plus/express/index/del'">删除</el-button>     
            </template>
            
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Track v-if="show_track" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'track')"></Track>
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
  import ExpressApi from '@/api/express.js';
  import Track from './dialog/Track.vue';
  import Add from './dialog/Add.vue';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
       Add,
      Edit,
    Track,
  },
    data() {
      return {
        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        show_track:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          order_no: '',
          express_no: '',
        },
        dataModel:[],
      };
    },
    created() {
   
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      openFullScreen2() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let url = baseUrl + '/index.php/job/Logistics/run?app_id='+this.tableData[0].app_id;
        window.open(url)
      },
      track(item){
        this.dataModel={
          express_log_id:item.express_log_id,
        };
        this.show_track=true;
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        ExpressApi.orderlist(Params).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        let Params = self.formInline;
        self.getTableList();
      },
      
      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          ExpressApi.del({
            express_log_id: row.express_log_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

      //操作 end
      /*打开添加*/
      addClick() {
        this.Oneform.model = {};
        this.Oneform.type = 'add';
        this.open_add = true;
      },
      //编辑
      editClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'edit';
        this.agent = $row;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if(f=='track'){
          this.show_track = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/express/index/list.vue